import { Registry } from "./registry";
import { Require } from "./require";
import { ServiceProvider } from "./service";


export interface Context
{
    require: Require;
}


export namespace Context
{
    export function create(): Context;
    export function create<T extends ContextRef>(options: ContextOptions<T>): Context & T;
    export function create(options?: ContextOptions): Context
    {
        const ref = options?.ref ?? {};
        const require = options?.require ?? Require.make(ref, options);
        const context = Object.assign(ref, { require });
        return context;
    }
}


export interface ContextOptions<T extends ContextRef = ContextRef>
{
    ref?: T;
    registry?: Registry;
    provider?: ServiceProvider;
    require?: Require;
}


export interface ContextRef extends Record<string, any>
{
    require?: Require;
}
